import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../../redux/store';
import { ToggleColorModeButton } from '../../../theme/ToggleColorModeButton';
import { useLoginForm } from './hooks';
import { login } from '../store';
import { LoginPageProps, LoginFormData } from './types';
import { AuthContainer, FormContainer, FormCard, Title } from '../styles';
import { ThemeProvider } from 'styled-components';
import LoginForm from './LoginForm';
import AuthBackground from './AuthBackground';

const LoginPage: React.FC<LoginPageProps> = ({ setIsLoggedIn, setRole, setLoginData }) => {
  const { control, handleSubmit, formState: { errors } } = useLoginForm();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isDarkMode } = useSelector((state: RootState) => state.theme);
  const { isLoggingIn, loginData, role: authRole, isLoggedIn: authLoggedIn } = useSelector((state: RootState) => state.auth);

  const hostname = window.location.hostname;
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'dark' | 'light' };

  // Sync Redux state to parent component props
  useEffect(() => {
    setIsLoggedIn(authLoggedIn);
    setLoginData(loginData);
    setRole(authRole);
  }, [authLoggedIn, loginData, authRole, setIsLoggedIn, setLoginData, setRole]);

  const onSubmit = async (data: LoginFormData): Promise<void> => {
    await dispatch(login({ data, hostname, navigate }));
  };

  // @ts-expect-error - react-hook-form type inference issue with yup resolver
  const handleFormSubmit = handleSubmit(onSubmit);

  return (
    <ThemeProvider theme={theme}>
      <AuthContainer>
        <AuthBackground isDarkMode={isDarkMode} />
        
        <ToggleColorModeButton
          width="24px"
          height="24px"
          iconButtonProps={{
            position: 'absolute',
            top: '5',
            right: '5',
            zIndex: 10,
          }}
        />

        <FormContainer>
          <FormCard>
            <Title>Login</Title>
            
            <LoginForm
              control={control as any}
              errors={errors}
              onSubmit={handleFormSubmit}
              isLoggingIn={isLoggingIn}
              hostname={hostname}
              onForgotPasswordClick={() => navigate('/forgot-password')}
            />
          </FormCard>
        </FormContainer>
      </AuthContainer>
    </ThemeProvider>
  );
};

export default LoginPage;
